<template>
  <div class="deactivate-complete--wrap">
    <div id="header">
      <h1 class="logo" slot="extra">
        <router-link :to="{ name: 'home' }">
          <i class="icon icon--logo-new"></i>
        </router-link>
      </h1>
    </div>
    <div id="content">
      <content-box :width="'400px'">
        <i class="icon icon--check-green-size50"></i>
        <p class="title">{{ $t('userInfo.myInformation.deactivateComplete.title') }}</p>
        <p class="desc" v-html="$t('userInfo.myInformation.deactivateComplete.desc')"></p>
        <ui-button :primary="true" @click="onGoToHome">
          {{ $t('userInfo.myInformation.deactivateComplete.button') }}
        </ui-button>
      </content-box>
    </div>
  </div>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'

export default {
  components: {
    ContentBox,
    UiButton
  },
  methods: {
    onGoToHome () {
      window.location.href = 'https://analytics.beusable.net'
    }
  },
  created () {
    if (!this.$route.params.isCompleteUser) {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.deactivate-complete--wrap {
  min-width: 1024px;
  height: 100%;
  position: relative;

  #header {
    padding-top: 13px;
    padding-left: 12px;

    .icon--logo-red {
      width: 112px;
      height: 33px;
    }
  }

  #content {
    /deep/ .content-box {
      @include positionXYcenter;
      text-align: center;
      padding: 55px 20px 37px 20px;
      box-sizing: border-box;
      border: 2px solid $brandColor;

      .title {
        font-size: 20px;
        font-weight: 500;
        color: #2f2f2f;
        margin-top: 22px;
      }

      .desc {
        font-size: 14px;
        color: #767676;
        margin-top: 12px;
        line-height: 1.43;
      }

      .ui-btn {
        margin-top: 20px;
      }
    }
  }
}
</style>
